<template>
  <d-modal class="move-popup">
    <d-modal-header>
      <div class="text-center w-100">
        <div>{{ $t('calendar.moveOrder') }}</div>
        <d-button
          class="move-popup-close"
          @click.prevent="handleClose">
          <i class="material-icons">close</i>
        </d-button>
      </div>
    </d-modal-header>
    <d-modal-body class="pb-1">
      <d-form>
        <validation-observer
          ref="move-popup-form"
          tag="form">
          <d-row>
            <d-col cols="5">
              <div class="form-group">
                <label>
                  {{ $t('calendar.howManyItemsMove') }}
                </label>

                <validation-provider
                  :rules="'required|min_value:1|max_value:' + maxQty"
                  name="quantity"
                  v-slot="{ errors }">
                  <d-input-group>
                    <d-input
                      :state="errors.length ? 'invalid' : null"
                      type="number"
                      :min="1"
                      :step="1"
                      class="text-right"
                      v-model="qty" />
                      <d-input-group-text slot="append">{{ $t('ui.piecesAbbr') }}</d-input-group-text>
                  </d-input-group>

                  <small>{{ $t('ui.maximum') }} {{ maxQty }} {{ $t('ui.piecesAbbr') }}</small>
                </validation-provider>
              </div>
            </d-col>

            <d-col cols="7">
              <div class="form-group">
                <label>
                  {{ $t('calendar.toWhatDay') }}
                </label>

                <validation-provider
                  rules="required"
                  name="date"
                  v-slot="{ errors }">
                  <date-range-picker
                    :locale-data="{
                      'firstDay': 1,
                      'format': 'dd-mm-yyyy',
                      'daysOfWeek': [$t('ui.daysOfWeek.sun'), $t('ui.daysOfWeek.mon'), $t('ui.daysOfWeek.tue'), $t('ui.daysOfWeek.wed'), $t('ui.daysOfWeek.thur'), $t('ui.daysOfWeek.fri'), $t('ui.daysOfWeek.sat')],
                      'monthNames': [$t('ui.monthNames.jan'), $t('ui.monthNames.feb'), $t('ui.monthNames.mar'), $t('ui.monthNames.apr'), $t('ui.monthNames.may'), $t('ui.monthNames.jun'), $t('ui.monthNames.jul'), $t('ui.monthNames.aug'), $t('ui.monthNames.sep'), $t('ui.monthNames.oct'), $t('ui.monthNames.nov'), $t('ui.monthNames.dec')],
                    }"
                    class="w-100"
                    :singleDatePicker="true"
                    :timePicker="false"
                    :showWeekNumbers="false"
                    :showDropdowns="false"
                    :autoApply="true"
                    v-model="date"
                    :ranges="false"
                    :linkedCalendars="false" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>
          </d-row>
        </validation-observer>
      </d-form>
    </d-modal-body>

    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="handleClose">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        :disabled="saveInProgress"
        @click.prevent="validateForm">
        {{ $t('ui.move') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  name: 'move-popup',
  props: [
    'itemID',
    'maxQty',
    'movePopupDayPopupDate'
  ],
  components: {
    'date-range-picker': DateRangePicker
  },
  data () {
    return {
      saveInProgress: false,
      qty: 0,
      date: {
        startDate: null,
        endDate: null
      }
    };
  },
  mounted () {
    this.qty = this.maxQty;
    this.date = {
      startDate: new Date(this.movePopupDayPopupDate),
      endDate: new Date(this.movePopupDayPopupDate)
    };
  },
  methods: {
    handleClose () {
      this.$bus.$emit('services-schedule-close-move-popup');
    },
    validateForm () {
      FormUtils.validate(this.$refs['move-popup-form'], this.saveMove);
    },
    saveMove () {
      this.saveInProgress = true;
      let preparedDate = [this.date.startDate.getFullYear(), this.date.startDate.getMonth() + 1, this.date.startDate.getDate()].map(n => n < 10 ? '0' + n : n).join('-');

      if (this.qty < this.maxQty) {
        FormUtils.submit({
          $http: this.$http,
          endpoint: '/services-schedule/update',
          formData: {
            items: [{
              action: 'move',
              id: this.itemID,
              date: preparedDate,
              quantity: this.qty
            }]
          },
          successTitle: this.$t('calendar.moveOrderPartSuccessTitle'),
          successText: this.$t('calendar.moveOrderSuccessText'),
          errorTitle: this.$t('ui.errorOccured'),
          errorText: this.$t('calendar.moveOrderErrorText'),
          successAction: () => {
            this.handleClose();
            this.saveInProgress = false;
            this.$bus.$emit('services-schedule-calendar-refresh');
            this.$bus.$emit('services-schedule-update-day-popup', this.movePopupDayPopupDate);
          },
          failAction: () => {
            this.saveInProgress = false;
          }
        });
      } else {
        FormUtils.submit({
          $http: this.$http,
          endpoint: '/services-schedule/update',
          formData: {
            items: [{
              action: 'update',
              id: this.itemID,
              date: preparedDate,
            }]
          },
          successTitle: this.$t('calendar.moveOrderSuccessTitle'),
          successText: this.$t('calendar.moveOrderSuccessText'),
          errorTitle: this.$t('ui.errorOccured'),
          errorText: this.$t('calendar.moveOrderErrorText'),
          successAction: () => {
            this.handleClose();
            this.saveInProgress = false;
            this.$bus.$emit('services-schedule-calendar-refresh');
            this.$bus.$emit('services-schedule-update-day-popup', this.movePopupDayPopupDate);
          },
          failAction: () => {
            this.saveInProgress = false;
          }
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.move-popup /deep/ .close {
  display: none;
}

.move-popup-close {
  background: transparent;
  box-shadow: none!important;
  border: none;
  color: #d22;
  padding: 0;
  position: absolute;
  right: 12px;
  top: 15px;

  &:active,
  &:focus,
  &:hover {
    background: transparent!important;
    box-shadow: none!important;
  }

  i {
    font-size: 24px;
  }
}

.is-draggable {
  cursor: move;
}

.has-save-in-progress {
  opacity: .35;
  pointer-events: none;
}
</style>
